import { getAppName } from '@libs/utils/helpers/getAppName';

export default function getRedlineAppName() {
  return getAppName();
}
